/* Tildas cart drawer: "Lägg till" in the "Komplettera och få fri frakt" box (snippets/tb-cart-suggest).
   Adds the variant, then re-renders the drawer and the cart bubble the same way Dawn does after an add. */
(function () {
  if (window.__tbCartSuggest) return;
  window.__tbCartSuggest = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tb-suggest-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-adding') || label;
    var drawer = document.querySelector('cart-drawer');
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-tb-suggest-add')), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.sections && drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  });

  // The heading count sits outside the part Dawn and the frame upsell re-render on a quantity
  // change or an added frame, so keep it in step with every cart update.
  function setCount(n) {
    document.querySelectorAll("[data-tb-cart-count]").forEach(function (el) { el.textContent = n > 0 ? " (" + n + ")" : ""; });
  }
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      var n = e && e.cartData && e.cartData.item_count;
      if (typeof n === "number") return setCount(n);
      fetch(((window.routes && window.routes.cart_url) || "/cart") + ".js").then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
    });
  }
})();
